import { FeatureToggleClientService } from 'feature-toggle-client';
const SHOW_CHATBOT_CLUSTER = 'show-chatbot-cluster';
const CUSTOM_AI_EXPERIMENT = 'new-onboarding-custom-ai';
const ONBOARDING_STEPPER = 'onboarding-steps-on-builder';
const ONBOARDING_STEPPER_TRACKINGS = 'onboarding-steps-on-builder-trackings';
const HIDE_HOME_METRICS = 'is-hiding-home-metrics';
export class HomeFeatures {
    static isShowChatbotClusterEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(SHOW_CHATBOT_CLUSTER);
    }
    static isCustomAIExperimentEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(CUSTOM_AI_EXPERIMENT);
    }
    static isOnboardingEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(ONBOARDING_STEPPER);
    }
    static isOnboardingTrackingsEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(ONBOARDING_STEPPER_TRACKINGS);
    }
    static isHideHomeMetricsEnabled() {
        return FeatureToggleClientService.getInstance().isFeatureEnabled(HIDE_HOME_METRICS);
    }
}
